import { render, staticRenderFns } from "./imageinput.vue?vue&type=template&id=6f200b20&"
import script from "./imageinput.vue?vue&type=script&lang=js&"
export * from "./imageinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports